import tafFetch from './_tafFetch'
import { GameToolServer } from '../assets/jce/GameToolServer'

export const GAME_TOOL_VERSION_TAF = {
  moduleName: 'webLiveUI',
  funcName: 'getGameToolVersion',
} as const

export function buildGameToolVersionRequest(toolId: string, version?: string) {
  return version === undefined ? { toolId } : { toolId, version }
}

export async function getGameToolVersion(toolId: string, version?: string) {
  const request = new GameToolServer.GetGameToolVersionReq()
  Object.assign(request, buildGameToolVersionRequest(toolId, version))
  return tafFetch({
    ...GAME_TOOL_VERSION_TAF,
    data: request,
    ReqClass: GameToolServer.GetGameToolVersionReq,
    RspClass: GameToolServer.GetGameToolVersionRsp,
  })
}
